/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import { Container, Grid, Paper, Typography } from "@mui/material";
import SectionHeading from "../../utils/SectionHeading";

export default function NewsPermotion() {
  // const imageData = [
  //   {
  //     image: '/images/news3.png',
  //     title: 'Scelerisque tincidunt felis Eget qum met arcu posuere vitae tempor.',
  //     date: 'Jan 2, 2025',
  //     comments: 'No Comments'
  //   },
  //   {
  //     image: '/images/news2.png',
  //     title: 'Scelerisque tincidunt felis Eget qum met arcu posuere vitae tempor.',
  //     date: 'Jan 2, 2025',
  //     comments: 'No Comments'
  //   },
  //   {
  //     image: '/images/news1.png',
  //     title: 'Scelerisque tincidunt felis Eget qum met arcu posuere vitae tempor.',
  //     date: 'Jan 2, 2025',
  //     comments: 'No Comments'
  //   }
  // ]
  const newsData = [
    {
      image: "/images/news3.png",
      title:
        "Introducing Transparent Medication Pricing: A New Era in Healthcare",
      date: "Jan 2, 2025",
      comments: "0 Comments",
    },
    {
      image: "/images/news2.png",
      title: "Global Pharmacy Network: Comparing Drug Prices Worldwide",
      date: "Dec 15, 2024",
      comments: "5 Comments",
    },
    {
      image: "/images/news1.png",
      title: "How RxPose is Changing the Way We Look at Healthcare Costs",
      date: "Nov 10, 2024",
      comments: "12 Comments",
    },
  ];

  return (
    <div className="news_promotion_main section_space">
      {/* <SectionHeading title={"News & Promotion"} /> */}
      <SectionHeading title={"Newsroom"} />
      <Container>
        <Grid container spacing={4} className="space-top">
          {newsData.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Paper elevation={3} className="news_box">
                <img
                  src={item.image}
                  alt={`Image ${index + 1}`}
                  style={{ width: "100%", height: "auto" }}
                />
                <div className="news_box_content">
                  <Typography
                    variant="subtitle1"
                    className="heading_four"
                    gutterBottom
                  >
                    {item.title}
                  </Typography>
                  <Typography
                    variant="caption"
                    className="caption_comment"
                  >{`${item.date} - ${item.comments}`}</Typography>
                </div>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </div>
  );
}
